import React from "react";
import Dialog from "@mui/material/Dialog";
import {useModalStore} from "@/Stores/Site/ModalStore";
import {Svg} from "@/shared/ui/Svg";
import {useLoginOrRegistrationModalStore} from "@/widgets/login-or-registration-modal";
import "@/Scss/Components/Modal/whySuchPriceModal.scss";

const WhySuchPriceModal = (props) => {
    const {productDataCurrent = {}, authCheck = false} = props;
    const {
        price = 0, // Цена
        card_price = 0, // Цена со скидкой
        discountData = [] // Массив скидок
    } = productDataCurrent;

    const whySuchPriceModalFlag = useModalStore(state => state.whySuchPriceModalFlag);
    const closeWhySuchPriceModal = useModalStore(state => state.closeWhySuchPriceModal);
    const openModal = useLoginOrRegistrationModalStore(s => s.actions.openModal);

    const closeModal = () => {
        closeWhySuchPriceModal();
    }

    const logIn = () => {
        openModal();
    }

    return (
        <Dialog
            id={`modal`}
            className={`modal`}
            open={whySuchPriceModalFlag}
            maxWidth={`xs`} //xs sm md lg xl
            onClose={closeModal}
            fullWidth
        >
            <div className={`modal__crossContainer`} onClick={closeModal}>
                <Svg id={`cross`} className={`svg--cross`} />
            </div>
            <div className={`modal__header`}>
                <div className={`modal__title`}>Почему такая цена?</div>
            </div>
            <div className={`modal__body`}>
                <div className={`whySuchPrice`}>
                    <div className={`whySuchPrice__mainContent`}>
                        <div className={`whySuchPrice__content`}>
                            <p className={`whySuchPrice__contentTitle`}>Цена без скидок</p>
                            <p className={`whySuchPrice__contentValue`}>{price.toLocaleString('ru')} ₽</p>
                        </div>
                        {discountData.map((el, index) => {
                            return <div key={index} className={`whySuchPrice__content`}>
                                <p className={`whySuchPrice__contentTitle`}>{el.title}</p>
                                <p className={`whySuchPrice__contentValue`}>-&nbsp;{el.value.toLocaleString('ru')}&nbsp;₽</p>
                            </div>
                        })}
                    </div>
                    <div className={`whySuchPrice__total`}>
                        <p className={`whySuchPrice__totalTitle`}>Итого</p>
                        <p className={`whySuchPrice__totalValue`}>{card_price.toLocaleString('ru')} ₽</p>
                    </div>
                    <div className={`whySuchPrice__save`}>
                        <p className={`whySuchPrice__saveTitle`}>Вы экономите</p>
                        <p className={`whySuchPrice__saveValue`}>-{(price - card_price).toLocaleString('ru')} ₽</p>
                    </div>
                    {!authCheck && (
                        <div className={`whySuchPrice__logInContainer`}>
                            <p className={`whySuchPrice__logInText`}>
                                Войдите, чтобы узнать скидку по бонусной программе PLATINA Benefits
                            </p>
                            <p className={`button whySuchPrice__logIn`} onClick={logIn}>
                                Войдите или зарегистрируйтесь
                            </p>
                        </div>
                    )}
                </div>
            </div>
        </Dialog>
    );
}

export default WhySuchPriceModal;
